import VueRouter from "vue-router";
import Login from "../views/Login";
import ErrorView from "../views/Error";
import National from "../views/national/index.vue";
import NationHome from "../views/national/page/home.vue";

Vue.use(VueRouter);
const routes = [
  //注入平台路由
  ...$platformRouter.pc,
  // {
  // 	path: "/pc/login",
  // 	meta: {
  // 		title: "登录",
  // 		enTitle: "Login",
  // 		needLogin: false,
  // 		waterMark: false,
  // 	},
  // 	component: Login,
  // },
  {
    path: "/pc/national",
    name: "national",
    meta: {
      title: "国家数据",
      titleCopy: "国家数据",
      enTitle: "National Data",
      needLogin: false,
      waterMark: false,
    },
    component: National,
    children: [
      {
        path: `/pc/national/:lang?/home`,
        name: "home",
        meta: {
          title: "国家数据",
          titleCopy: "首页",
          enTitle: "Home",
          needLogin: false,
          referrer: "never",
        },
        component: NationHome,
      },
      {
        path: `/pc/national/:lang?/register`,
        name: "register",
        meta: {
          title: "国家数据",
          titleCopy: "注册",
          enTitle: "Register",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "NationRegister" */ "../views/national/page/register.vue"),
      },
      {
        path: `/pc/national/:lang?/login`,
        name: "login",
        meta: {
          title: "国家数据",
          titleCopy: "登录",
          enTitle: "Login",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "NationLogin" */ "../views/national/page/login.vue"),
      },
      {
        path: `/pc/national/:lang?/updatePassword`,
        meta: {
          title: "国家数据",
          titleCopy: "忘记密码",
          enTitle: "Forget Password",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "UpdatePasswordPage" */ "../views/national/page/updatePasswordPage.vue"),
      },
      {
        path: `/pc/national/:lang?/editPassword`,
        name: "editPassword",
        meta: {
          title: "国家数据",
          titleCopy: "修改密码",
          enTitle: "Change Password",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "editPassword" */ "../views/national/page/editPasswordPage.vue"),
      },
      {
        path: `/pc/national/:lang?/updateUserInfo`,
        meta: {
          title: "国家数据",
          titleCopy: "设置",
          enTitle: "Edit Profile",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "UpdateUserinfoPage" */ "../views/national/page/updateUserinfoPage.vue"),
      },
      {
        path: `/pc/national/:lang?/protocol`,
        meta: {
          title: "国家数据",
          titleCopy: "免责声明",
          enTitle: "Disclaimer",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "ProtocolPage" */ "../views/national/page/protocolPage.vue"),
      },
      {
        path: `/pc/national/:lang?/home/report`,
        name: "quickSearch",
        meta: {
          title: "国家数据",
          titleCopy: "快速查询",
          enTitle: "Browse Topics",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "ReportPage" */ "../views/national/page/reportPage.vue"),
      },
      {
        path: `/pc/national/:lang?/home/news`,
        name: "news",
        meta: {
          title: "国家数据",
          titleCopy: "最新发布",
          enTitle: "Latest Release",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "NewsListPage" */ "../views/national/page/newsListPage.vue"),
      },
      {
        path: `/pc/national/:lang?/monthData`,
        name: "monthData",
        meta: {
          title: "国家数据",
          titleCopy: "月度数据",
          enTitle: "Monthly",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataPage" */ "../views/national/page/dataPage.vue"),
      },
      {
        path: `/pc/national/:lang?/quarterData`,
        name: "quarterData",
        meta: {
          title: "国家数据",
          titleCopy: "季度数据",
          enTitle: "Quarterly",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataPage" */ "../views/national/page/dataPage.vue"),
      },
      {
        path: `/pc/national/:lang?/yearData`,
        name: "yearData",
        meta: {
          title: "国家数据",
          titleCopy: "年度数据",
          enTitle: "Annual",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataPage" */ "../views/national/page/dataPage.vue"),
      },
      {
        path: `/pc/national/:lang?/hongKongYearData`,
        name: "hongKongYearData",
        meta: {
          title: "国家数据",
          titleCopy: "香港特别行政区年度数据",
          enTitle: "hongKongYearData",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataPage" */ "../views/national/page/dataPage.vue"),
      },
      {
        path: `/pc/national/:lang?/macaoYearData`,
        name: "macaoYearData",
        meta: {
          title: "国家数据",
          titleCopy: "澳门特别行政区年度数据",
          enTitle: "macaoYearData",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataPage" */ "../views/national/page/dataPage.vue"),
      },
      {
        path: `/pc/national/:lang?/taiwanYearData`,
        name: "taiwanYearData",
        meta: {
          title: "国家数据",
          titleCopy: "台湾省年度数据",
          enTitle: "taiwanYearData",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataPage" */ "../views/national/page/dataPage.vue"),
      },
      {
        path: `/pc/national/:lang?/areaData`,
        name: "areaData",
        meta: {
          title: "国家数据",
          titleCopy: "地区数据",
          enTitle: "Regional",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataPage" */ "../views/national/page/dataPage.vue"),
      },
      {
        path: `/pc/national/:lang?/fsMonthData`,
        name: "fsMonthData",
        meta: {
          title: "国家数据",
          titleCopy: "分省月度数据",
          enTitle: "Monthly By Province",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataPage" */ "../views/national/page/dataPage.vue"),
      },
      {
        path: `/pc/national/:lang?/fsQuarterData`,
        name: "fsQuarterData",
        meta: {
          title: "国家数据",
          titleCopy: "分省季度数据",
          enTitle: "Quarterly By Province",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataPage" */ "../views/national/page/dataPage.vue"),
      },
      {
        path: `/pc/national/:lang?/fsYearData`,
        name: "fsYearData",
        meta: {
          title: "国家数据",
          titleCopy: "分省年度数据",
          enTitle: "Annual By Province",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataPage" */ "../views/national/page/dataPage.vue"),
      },
      {
        path: `/pc/national/:lang?/mainMonthData`,
        name: "mainMonthData",
        meta: {
          title: "国家数据",
          titleCopy: "主要城市月度价格",
          enTitle: "Monthly Prices By Selected Cities",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataPage" */ "../views/national/page/dataPage.vue"),
      },
      {
        path: `/pc/national/:lang?/mainYearData`,
        name: "mainYearData",
        meta: {
          title: "国家数据",
          titleCopy: "主要城市年度数据",
          enTitle: "Annual By Selected Cities",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataPage" */ "../views/national/page/dataPage.vue"),
      },
      {
        path: "/pc/national/gatMonthData",
        name: "gatMonthData",
        meta: {
          title: "国家数据",
          titleCopy: "港澳台月度数据",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataPage" */ "../views/national/page/dataPage.vue"),
      },
      {
        path: "/pc/national/gatYearData",
        name: "gatYearData",
        meta: {
          title: "国家数据",
          titleCopy: "港澳台年度数据",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataPage" */ "../views/national/page/dataPage.vue"),
      },
      {
        path: "/pc/national/generalSurveyData",
        name: "generalSurveyData",
        meta: {
          title: "国家数据",
          titleCopy: "普查数据",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "TipPage" */ "../views/national/page/tipPage.vue"),
      },
      {
        path: "/pc/national/departmentData",
        name: "departmentData",
        meta: {
          title: "国家数据",
          titleCopy: "部门数据",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DepartmentPage" */ "../views/national/page/departmentPage.vue"),
      },
      {
        path: "/pc/national/internationalData",
        name: "internationalData",
        meta: {
          title: "国家数据",
          titleCopy: "国际数据",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "TipPage" */ "../views/national/page/tipPage.vue"),
      },
      {
        path: "/pc/national/countryMonthData",
        name: "countryMonthData",
        meta: {
          title: "国家数据",
          titleCopy: "主要国家(地区)月度数据",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataPage" */ "../views/national/page/dataPage.vue"),
      },
      {
        path: "/pc/national/:lang?/help",
        name: "help",
        meta: {
          title: "国家数据",
          titleCopy: "主要国家(地区)月度数据",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataPage" */ "../views/national/page/help.vue"),
      },
      {
        path: "/pc/national/:lang?/aboutctryinfo",
        name: "aboutctryinfo",
        meta: {
          title: "国家数据",
          titleCopy: "",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataPage" */ "../views/national/page/aboutctryinfo.vue"),
      },
      {
        path: "/pc/national/sdjjtMonthData",
        name: "sdjjtMonthData",
        meta: {
          title: "国家数据",
          titleCopy: "三大经济体月度数据",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataPage" */ "../views/national/page/dataPage.vue"),
      },
      {
        path: "/pc/national/gjscMonthPrice",
        name: "gjscMonthPrice",
        meta: {
          title: "国家数据",
          titleCopy: "国际市场月度商品价格",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataPage" */ "../views/national/page/dataPage.vue"),
      },
      {
        path: "/pc/national/countryYearData",
        name: "countryYearData",
        meta: {
          title: "国家数据",
          titleCopy: "主要国家年度数据",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataPage" */ "../views/national/page/dataPage.vue"),
      },
      {
        path: "/pc/national/internationOrgWeb",
        name: "internationOrgWeb",
        meta: {
          title: "国家数据",
          titleCopy: "国际组织网站",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "internationOrgWeb" */ "../views/national/page/internationOrgWeb.vue"),
      },
      {
        path: "/pc/national/countryStatisWeb",
        name: "countryStatisWeb",
        meta: {
          title: "国家数据",
          titleCopy: "各国统计网站",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "countryStatisWeb" */ "../views/national/page/countryStatisWeb.vue"),
      },
      {
        path: `/pc/national/:lang?/dataview`,
        name: "dataview",
        meta: {
          title: "国家数据",
          titleCopy: "可视化产品",
          enTitle: "Visualization",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "DataviewPage" */ "../views/national/page/dataviewPage.vue"),
      },
      {
        path: `/pc/national/:lang?/publication`,
        name: "publication",
        meta: {
          title: "国家数据",
          titleCopy: "出版物",
          enTitle: "Publications",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "publication" */ "../views/national/page/publication.vue"),
      },
      {
        path: `/pc/national/:lang?/myCollect`,
        name: "myCollect",
        meta: {
          title: "国家数据",
          titleCopy: "我的收藏",
          enTitle: "Favorites",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "myCollect" */ "../views/national/page/myCollect.vue"),
      },
      {
        path: "/pc/national/search",
        name: "search",
        meta: {
          title: "国家数据",
          titleCopy: "搜索",
          enTitle: "Search",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "SearchPage" */ "../views/national/page/searchPage.vue"),
      },
      {
        path: "/pc/national/searchHome",
        name: "searchHome",
        meta: {
          title: "国家数据",
          titleCopy: "搜索",
          enTitle: "searchHome",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "searchHome" */ "../views/national/page/searchHome.vue"),
      },
      {
        path: "/pc/national/:lang?/searchInstruction",
        name: "searchHome",
        meta: {
          title: "国家数据",
          titleCopy: "搜索",
          enTitle: "searchInstruction",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "searchHome" */ "../views/national/page/searchInstruction.vue"),
      },
      {
        path: "/pc/national/promotionalVideo",
        name: "searchHome",
        meta: {
          title: "国家数据",
          titleCopy: "宣传视频",
          enTitle: "promotionalVideo",
          needLogin: false,
        },
        component: () => import(/* webpackChunkName: "searchHome" */ "../views/national/page/promotionalVideo.vue"),
      },
    ],
  },
  {
    path: `/pc/national/:lang?/map`,
    name: "map",
    meta: {
      title: "国家数据",
      titleCopy: "国家数据",
      enTitle: "Nationl Data",
      needLogin: false,
      waterMark: false,
    },
    component: () => import(/* webpackChunkName: "MapPage" */ "../views/national/page/mapPage.vue"),
  },
  // 强制匹配404页面
  {
    path: "*",
    component: ErrorView,
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

dsf.init.initRouter(router, "pc");

export default router;
